/**
 * Puente entre el selector de variantes del tema y Globo Product Options.
 *
 * Globo vigila el campo oculto del formulario con el selector que trae por
 * defecto, "[data-gpo-product-variant-selector],[name=id]", y espera un evento
 * `change` en el. Pero este tema cambia ese valor por JavaScript al re-renderizar
 * la seccion, y asignar un valor por codigo no dispara `change`; ademas el nodo
 * se sustituye entero, con lo que el oyente de la app se pierde.
 *
 * Resultado: la app no se entera del cambio y pinta los campos condicionales de
 * la variante anterior. Hacia falta pulsar dos veces.
 *
 * Aqui, en cuanto el tema confirma la variante, ponemos el valor en todos los
 * campos [name=id] de los formularios de compra y lanzamos el `change` que la
 * app espera. Alineamos tambien la URL, que es de donde lee al inicializarse.
 */

import { StandardEvents } from '@shopify/events';

/** El tema re-renderiza la seccion: repetimos por si sustituye los nodos. */
const REINTENTOS_MS = [0, 300, 800];

/** @type {number[]} */
let temporizadores = [];

function alinearUrl(/** @type {string} */ variante) {
  const url = new URL(window.location.href);
  if (url.searchParams.get('variant') === variante) return;
  url.searchParams.set('variant', variante);
  window.history.replaceState(window.history.state, '', url);
}

function avisarAGlobo(/** @type {string} */ variante) {
  const campos = document.querySelectorAll('form[action*="/cart/add"] input[name="id"]');

  for (const campo of campos) {
    if (!(campo instanceof HTMLInputElement)) continue;
    if (campo.value !== variante) campo.value = variante;
    campo.dispatchEvent(new Event('change', { bubbles: true }));
  }

  try {
    window.GPOConfigs?.initialize?.();
  } catch (error) {
    console.warn('[MarkOn] No se pudo resincronizar Globo Product Options', error);
  }
}

/** @param {Event} event */
function alCambiarVariante(event) {
  const detalle = /** @type {CustomEvent<{ variantId?: string | number }>} */ (event).detail;
  if (detalle?.variantId == null) return;
  const variante = String(detalle.variantId);

  alinearUrl(variante);

  for (const t of temporizadores) clearTimeout(t);
  temporizadores = REINTENTOS_MS.map((ms) => setTimeout(() => avisarAGlobo(variante), ms));
}

document.addEventListener(StandardEvents.productSelect, alCambiarVariante);
